import { Loader2, CheckCircle2, Clock, AlertCircle, XCircle } from 'lucide-react';

export const STALE_RESEARCH_MS = 45 * 60 * 1000;
export const STALE_RESEARCH_AZURE_COGNITIVE_MS = 30 * 60 * 1000;

export function formatDurationMs(ms: number): string {
  if (ms < 60_000) return `${Math.max(1, Math.round(ms / 1000))} s`;
  const m = Math.floor(ms / 60_000);
  if (m < 60) return `${m} Min.`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return `${h} h ${rem} Min.`;
}

export function RunStatusIcon({ status }: { status: string }) {
  if (status === 'running') return <Loader2 size={14} className="animate-spin text-muted" />;
  if (status === 'completed') return <CheckCircle2 size={14} className="text-muted" />;
  if (status === 'failed') return <AlertCircle size={14} className="text-danger" />;
  if (status === 'cancelled') return <XCircle size={14} className="text-muted" />;
  return <Clock size={14} className="text-muted" />;
}

export function truncateQuery(q: string, max = 72): string {
  const t = q.trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1)}…`;
}
